export enum SimType {
  ODIDO = 'BEN',
  KPN = 'GSM1',
}

export function getDefaultSimType(): SimType {
  return SimType.ODIDO;
}
